import {
  availableDeviceTypes,
  deltaDeviceTypeOptions,
  deviceErrors,
  deviceKitNameType,
  deviceTypeOptions,
  deviceTypesConfig,
  ilumaDeviceTypeOptions,
  strCode
} from "../consts";
import { t } from "../services";
import deviceUtil from "./deviceUtil";
import { selectAppTypes, selectUserMarkets } from "../state/selectors";
import { getState } from "../state/store";

const formatDevices = (devices) => {
  return devices.map((device) => {
    Object.keys(device).forEach((key) => {
      if (device[key] === "null") {
        device[key] = null;
      }
    });

    const type = device?.type?.toUpperCase();

    const deviceModel = deviceUtil.getDeviceTypeBySerialNumber(device.dusn);
    const deviceName = device?.device_model
      ? device.device_model
      : deviceUtil.getDeviceModelNameByType(deviceModel);

    const { material_group, material_brand_family, material_model_number, material_color } =
      device ?? {};

    const material = {
      materialGroup: material_group,
      materialBrandFamily: material_brand_family,
      materialModelNumber: material_model_number,
      materialColor: material_color
    };

    const isMercuryDevice = deviceUtil.getIsMercuryDevice(deviceName);
    const deviceImage = deviceUtil.getDeviceImage(material, deviceModel);

    return { ...device, type, deviceModel, deviceName, deviceImage, isMercuryDevice };
  });
};

const filterDeviceTypeOptions = (deviceName) => {
  const deviceTypes = availableDeviceTypes[deviceName] ?? [];

  const extendedDeviceTypeOptions = [
    ...deviceTypeOptions,
    ...deltaDeviceTypeOptions,
    ...ilumaDeviceTypeOptions
  ];

  const filteredDeviceTypeOptions = extendedDeviceTypeOptions.filter((opt) =>
    deviceTypes.includes(opt.id)
  );

  return filteredDeviceTypeOptions;
};

const validateDusn = (dusn, selectedDeviceName, selectedDeviceType) => {
  const deviceModel = deviceUtil.getDeviceTypeBySerialNumber(dusn);
  const deviceName = deviceUtil.getDeviceModelNameByType(deviceModel);

  const deviceTypes = deviceTypesConfig[deviceName]
    ? deviceTypesConfig[deviceName][deviceModel] ?? []
    : [];

  if (deviceName === selectedDeviceName) {
    return {
      isDeviceModelValid: true,
      isDeviceTypeValid: deviceTypes.includes(selectedDeviceType)
    };
  }

  if (deviceName === deviceKitNameType.DEV_TYPE_UNKNOWN) {
    const isMercuryDevice = deviceUtil.getIsMercuryDevice(selectedDeviceName);

    if (isMercuryDevice) {
      const isMercuryDusnValid = deviceUtil.validateMercuryDeviceDusn(dusn);

      return {
        isDeviceModelValid: isMercuryDusnValid,
        isDeviceTypeValid: true
      };
    } else {
      return {
        isDeviceModelValid: false,
        isDeviceTypeValid: true
      };
    }
  } else {
    return {
      isDeviceModelValid: false,
      isDeviceTypeValid: true
    };
  }
};

const parseDeviceErrorMessage = (error) => {
  let errorMessage = deviceErrors[error] ?? error;

  if (error?.includes("INVALID_PARAMETER_PROVIDED")) {
    const invalidParameter = error.split(":")[1];
    errorMessage = t(strCode.INVALID_PARAMETER_PROVIDED, { invalidParameter });
  }
  
  return errorMessage;
};

const filterFleetManagerNotificationCampaigns = (campaigns) => {
  const userMarkets = selectUserMarkets()(getState());
  const userAppTypes = selectAppTypes()(getState());

  return campaigns.filter(
    (campaign) =>
      userAppTypes?.some(
        (app) => campaign?.audience && campaign?.audience?.appTypes?.includes(app)
      ) ||
      userMarkets?.some((market) => campaign.markets?.includes(market)) ||
      !campaign?.audience
  );
};

const formatDeviceKitList = (deviceKitList) => {
  return deviceKitList.map((deviceKit) => {
    const { device_kit_codentify, device_codentify } = deviceKit ?? {};

    return {
      deviceKitCodentify: device_kit_codentify,
      deviceCodentify: device_codentify
    };
  });
};

const fleetManagementUtil = {
  formatDevices,
  filterDeviceTypeOptions,
  validateDusn,
  parseDeviceErrorMessage,
  filterFleetManagerNotificationCampaigns,
  formatDeviceKitList
};

export default fleetManagementUtil;
